import axios from 'axios';
import { API_BASE_URL, AUTH_BASE_URL, API_ENDPOINTS, buildApiUrl, API_CONFIG, useDjangoAPI } from '../config/api';

console.log('AuthService using API:', useDjangoAPI ? 'Django Backend' : 'Express Backend');
console.log('Auth API Base URL:', AUTH_BASE_URL);
console.log('Business API Base URL:', API_BASE_URL);

class AuthService {
  async login(email, password) {
    try {
      // Auth requests go to Auth Service (Port 8000)
      const loginUrl = `${AUTH_BASE_URL}${API_ENDPOINTS.AUTH.LOGIN}`;
      console.log('=== LOGIN DEBUG ===');
      console.log('Login attempt to:', loginUrl);
      console.log('Login credentials:', { email, password: '***' });
      console.log('useDjangoAPI:', useDjangoAPI);
      console.log('AUTH_BASE_URL:', AUTH_BASE_URL);
      console.log('API_ENDPOINTS.AUTH.LOGIN:', API_ENDPOINTS.AUTH.LOGIN);
      console.log('==================');

      const response = await axios.post(loginUrl, {
        email,
        password
      });

      console.log('Login response:', response.data);

      // Handle Django API response format (ARGUS Auth Service - JWT)
      if (useDjangoAPI) {
        // ARGUS Auth Service returns { access, refresh, user }
        if (response.data.access) {
          localStorage.setItem('authToken', response.data.access);
          if (response.data.refresh) {
            localStorage.setItem('refreshToken', response.data.refresh);
          }
          localStorage.setItem('user', JSON.stringify(response.data.user || { email }));
          return { success: true, user: response.data.user || { email } };
        }
      } else {
        // Express API response format
        if (response.data.token) {
          localStorage.setItem('authToken', response.data.token);
          localStorage.setItem('user', JSON.stringify(response.data.user));
          return { success: true, user: response.data.user };
        }
      }

      return { success: false, message: 'Keine gültige Antwort vom Server' };
    } catch (error) {
      console.error('Login error:', error);
      console.error('Error details:', error.response?.data || error.message);
      console.error('Full error object:', error);
      console.error('Request config:', error.config);
      console.error('Response status:', error.response?.status);
      console.error('Response headers:', error.response?.headers);
      
      // Detaillierte Fehlermeldung
      let errorMessage = 'Ein Fehler ist aufgetreten';
      if (error.response) {
        // Der Server hat mit einem Fehlerstatuscode geantwortet
        errorMessage = `Server-Fehler: ${error.response.status} - ${error.response.data?.message || error.response.statusText}`;
      } else if (error.request) {
        // Die Anfrage wurde gestellt, aber keine Antwort erhalten
        errorMessage = 'Keine Antwort vom Server erhalten. Bitte überprüfen Sie Ihre Internetverbindung.';
      } else {
        // Etwas ist beim Einrichten der Anfrage schief gelaufen
        errorMessage = `Fehler bei der Anfrage: ${error.message}`;
      }
      
      return {
        success: false,
        message: errorMessage
      };
    }
  }
  
  logout() {
    localStorage.removeItem('authToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user');
  }
  
  getCurrentUser() {
    const userStr = localStorage.getItem('user');
    if (!userStr) return null;
    return JSON.parse(userStr);
  }
  
  getToken() {
    return localStorage.getItem('authToken');
  }
  
  async isLoggedIn() {
    const token = this.getToken();
    if (!token) return false;

    try {
      // Token validation goes to Auth Service (Port 8000)
      const validateUrl = `${AUTH_BASE_URL}${API_ENDPOINTS.AUTH.VALIDATE_TOKEN}`;

      if (useDjangoAPI) {
        // For ARGUS Auth Service (JWT), use Bearer token in Authorization header
        const response = await axios.get(validateUrl, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        });
        return response.data.valid || response.status === 200;
      } else {
        // For Express, send token in body
        const response = await axios.post(validateUrl, { token });
        return response.data.success;
      }
    } catch (error) {
      console.log('Token validation failed:', error.response?.status);
      // Nur bei expliziten 401/403 Fehlern ausloggen, nicht bei Netzwerkfehlern
      if (error.response?.status === 401 || error.response?.status === 403) {
        this.logout(); // Token ungültig, ausloggen
      }
      return false;
    }
  }
  
  // Setup Axios Interceptor für automatisches Token-Handling
  setupAxiosInterceptors() {
    axios.interceptors.request.use(
      (config) => {
        const token = this.getToken();
        if (token) {
          // ARGUS Auth Service uses JWT with Bearer token
          config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  }
}

const authService = new AuthService();
authService.setupAxiosInterceptors();
export default authService;
